"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LitigationStages = exports.LitigationAreas = exports.usersToTrackTime = exports.maxFileSize = exports.clientDataSchema = exports.ReasonForPIEmpDisplayMapping = exports.ReasonForNAEmpDisplayMapping = exports.ReasonForDeclineWCDisplayText = exports.ReasonForReferPIDisplayText = exports.ReasonForDeclinePIDisplayText = exports.ReasonForKeepPIDisplayText = exports.CSADisplayText = exports.InjuriesDisplayMapping = exports.PaidTimeDisplayMapping = exports.EmployeePaidDisplayMapping = exports.ContactReasonDisplayMapping = exports.CategoryMapping = exports.StageColorsMapping = exports.IntakeStatus = exports.LeadStatus = exports.SummaryTypeText = exports.SummaryType = exports.StageColors = exports.Stage = exports.LeadType = exports.errorInstructions = exports.RadioYesOption = void 0;
var yup = require("yup");
var api_1 = require("../../../../api");
var AdminLeadStatus_1 = require("../../../../api/models/AdminLeadStatus");
var Helpers_1 = require("../../../../services/Helpers");
exports.RadioYesOption = Helpers_1.HelpersService.getEnumKeyByEnumValue(api_1.RadioOptions, api_1.RadioOptions.YES);
exports.errorInstructions = "Please try again. If the error still persists, please contact us.";
var LeadType;
(function (LeadType) {
    LeadType["Admin"] = "Admin";
    LeadType["Attorney"] = "Attorney";
    LeadType["Case"] = "Case";
    LeadType["StaffAttorney"] = "StaffAttorney";
})(LeadType = exports.LeadType || (exports.LeadType = {}));
// Leads table
var Stage;
(function (Stage) {
    Stage["new"] = "NEW";
    Stage["shared"] = "SHARED";
    Stage["winner"] = "WINNER";
    Stage["toSign"] = "TO SIGN";
    Stage["signed"] = "SIGNED";
    //attorney view stages
    Stage["accepted"] = "Accepted";
    Stage["rejected"] = "Rejected";
    Stage["intake"] = "Intake";
    Stage["won"] = "Opportunity won";
    Stage["lost"] = "Opportunity lost";
})(Stage = exports.Stage || (exports.Stage = {}));
var StageColors;
(function (StageColors) {
    StageColors["cyan"] = "cyan";
    StageColors["purple"] = "purple";
    StageColors["dirtyYellow"] = "dirtyYellow";
    StageColors["dirtyBlue"] = "dirtyBlue";
    StageColors["dirtyGreen"] = "dirtyGreen";
    StageColors["darkGray"] = "darkGray";
    StageColors["brown"] = "brown";
    StageColors["primary"] = "primary";
})(StageColors = exports.StageColors || (exports.StageColors = {}));
var SummaryType;
(function (SummaryType) {
    SummaryType["Full"] = "Full";
    SummaryType["Redacted"] = "Redacted";
})(SummaryType = exports.SummaryType || (exports.SummaryType = {}));
var SummaryTypeText;
(function (SummaryTypeText) {
    SummaryTypeText["Full"] = "Full summary";
    SummaryTypeText["Redacted"] = "Redacted summary";
})(SummaryTypeText = exports.SummaryTypeText || (exports.SummaryTypeText = {}));
var LeadStatus;
(function (LeadStatus) {
    LeadStatus["Completed"] = "Completed";
    LeadStatus["Rejected"] = "Rejected";
})(LeadStatus = exports.LeadStatus || (exports.LeadStatus = {}));
var IntakeStatus;
(function (IntakeStatus) {
    IntakeStatus["Allow"] = "Allow";
    IntakeStatus["Block"] = "Block";
    IntakeStatus["Initiate"] = "Initiate";
})(IntakeStatus = exports.IntakeStatus || (exports.IntakeStatus = {}));
exports.StageColorsMapping = (_a = {},
    _a[AdminLeadStatus_1.AdminLeadStatus.NEW] = StageColors.cyan,
    _a[AdminLeadStatus_1.AdminLeadStatus.SHARED] = StageColors.purple,
    _a[AdminLeadStatus_1.AdminLeadStatus.WINNER_SELECTED] = StageColors.dirtyYellow,
    _a[AdminLeadStatus_1.AdminLeadStatus.SENT_FOR_SIGNING] = StageColors.dirtyBlue,
    _a[AdminLeadStatus_1.AdminLeadStatus.SIGNED] = StageColors.primary,
    _a[AdminLeadStatus_1.AdminLeadStatus.PAID] = StageColors.dirtyGreen,
    //new intake
    _a[AdminLeadStatus_1.AdminLeadStatus.DRAFT] = StageColors.darkGray,
    _a[api_1.AttorneyApprovalStatus.IN_PROCESS] = StageColors.cyan,
    _a[api_1.AttorneyApprovalStatus.MORE_INFO_PROVIDED] = StageColors.purple,
    _a[api_1.AttorneyApprovalStatus.MORE_INFO_REQUESTED] = StageColors.purple,
    //keep
    _a[AdminLeadStatus_1.AdminLeadStatus.CONTRACT_SENT] = StageColors.purple,
    _a[AdminLeadStatus_1.AdminLeadStatus.CONTRACT_SIGNED] = StageColors.dirtyYellow,
    _a[AdminLeadStatus_1.AdminLeadStatus.SUPPLEMENTAL_ASSIGNED] = StageColors.dirtyBlue,
    _a[AdminLeadStatus_1.AdminLeadStatus.DONE] = StageColors.dirtyGreen,
    //attorneys
    _a[api_1.AttorneyLeadStatus.NEW] = StageColors.cyan,
    _a[api_1.AttorneyLeadStatus.ACCEPTED] = StageColors.purple,
    _a[api_1.AttorneyLeadStatus.REJECTED] = StageColors.dirtyYellow,
    //[AttorneyLeadStatus.INTRODUCTION]: StageColors.dirtyYellow,
    _a[api_1.AttorneyLeadStatus.WON] = StageColors.dirtyYellow,
    _a[api_1.AttorneyLeadStatus.LOST] = StageColors.dirtyBlue,
    _a[api_1.AttorneyLeadStatus.SIGNED] = StageColors.primary,
    _a[api_1.AttorneyLeadStatus.PAID] = StageColors.dirtyGreen,
    //archived
    _a[AdminLeadStatus_1.AdminLeadStatus.CLIENT_REFERED] = StageColors.purple,
    _a[AdminLeadStatus_1.AdminLeadStatus.DECLINED] = StageColors.brown,
    _a[AdminLeadStatus_1.AdminLeadStatus.NGC] = StageColors.dirtyBlue,
    _a[AdminLeadStatus_1.AdminLeadStatus.N_A] = StageColors.dirtyYellow,
    _a[AdminLeadStatus_1.AdminLeadStatus.CSADECLINED] = StageColors.primary,
    _a[AdminLeadStatus_1.AdminLeadStatus.CLIENT_RETAINED] = StageColors.dirtyGreen,
    _a[AdminLeadStatus_1.AdminLeadStatus.ATTORNEY_REJECT] = StageColors.brown,
    //extensions
    _a[api_1.TaskExtentionStatus.REQUESTED] = StageColors.dirtyBlue,
    _a[api_1.TaskExtentionStatus.APPROVED] = StageColors.dirtyGreen,
    _a[api_1.TaskExtentionStatus.REJECTED] = StageColors.brown,
    _a[api_1.TaskExtentionStatus.AUTHORIZED] = StageColors.purple,
    _a[api_1.TaskExtentionStatus.UNAUTHORIZED] = StageColors.primary,
    _a[api_1.TaskExtentionStatus.TASK_REMOVED] = StageColors.dirtyBlue,
    _a[api_1.TaskExtentionStatus.TASK_COMPLETED] = StageColors.dirtyYellow,
    _a);
exports.CategoryMapping = (_b = {},
    _b[api_1.Category.EMPLOYMENT] = "Employment",
    _b[api_1.Category.WORKERS_COMPENSATION] = "Workers compensation",
    _b[api_1.Category.PERSONAL_INJURY] = "Personal Injury",
    _b[api_1.Category.CLASS_ACTION] = "Class Action",
    _b);
exports.ContactReasonDisplayMapping = (_c = {},
    _c[api_1.ContactReason.DISCRIMINATION] = "Discrimination",
    _c[api_1.ContactReason.HARASSMENT] = "Harassment",
    _c[api_1.ContactReason.RETALIATION] = "Retaliation",
    _c[api_1.ContactReason.BREACH_OF_CONTRACT] = "Breach of Contract",
    _c[api_1.ContactReason.CLASS_ACTION] = "Class Actions - Problem with wages/​getting breaks",
    _c);
exports.EmployeePaidDisplayMapping = (_d = {},
    _d[api_1.EmployeePaidType.MULTIPLE] = "More than one rate of pay",
    _d[api_1.EmployeePaidType.SALARY] = "Salary",
    _d[api_1.EmployeePaidType.COMMISSION] = "On a commission basis",
    _d[api_1.EmployeePaidType.PIECE_RATE] = "On a piece-rate basis",
    _d[api_1.EmployeePaidType.BONUSES] = "Bonuses",
    _d[api_1.EmployeePaidType.TIPS] = "Tips",
    _d[api_1.EmployeePaidType.HOURLY] = "Hourly",
    _d[api_1.EmployeePaidType.OTHER] = "Other",
    _d);
exports.PaidTimeDisplayMapping = (_e = {},
    _e[api_1.PaidWithheld.WEEKLY_OVERTIME] = "Weekly Overtime",
    _e[api_1.PaidWithheld.DAILY_OVERTIME] = "Daily Overtime",
    _e[api_1.PaidWithheld.DOUBLE_TIME] = "Double Time",
    _e[api_1.PaidWithheld.TRAVEL_TIME] = "Travel Time",
    _e[api_1.PaidWithheld.REPORTING_TIME] = "Reporting Time",
    _e[api_1.PaidWithheld.STANDBY_TIME] = "Standby Time",
    _e[api_1.PaidWithheld.PREP_TIME] = "Prep Time",
    _e[api_1.PaidWithheld.TRAINING_TIME] = "Training Time",
    _e[api_1.PaidWithheld.ON_CALL_TIME] = "On-Call Time",
    _e[api_1.PaidWithheld.BONUS] = "Bonus/Commissions",
    _e[api_1.PaidWithheld.UNUSED_VACATION] = "Unused Vacation",
    _e[api_1.PaidWithheld.SICK_LEAVE] = "Sick Leave",
    _e[api_1.PaidWithheld.GRATUITIES] = "Gratuities(e.g. does manager/​supervisor take any tips?)",
    _e[api_1.PaidWithheld.OTHER] = "Other",
    _e);
exports.InjuriesDisplayMapping = (_f = {},
    _f[api_1.Injuries.BRAIN_INJURY_CONCUSSION] = "Brain Injury/​Concussion",
    _f[api_1.Injuries.BROKEN_BONES] = "Broken Bones",
    _f[api_1.Injuries.LOSS_OF_LIFE] = "Loss of life",
    _f[api_1.Injuries.LOST_LIMB] = "Lost Limb",
    _f[api_1.Injuries.SPINAL_CORD] = "Spinal Cord Injury or Paralysis",
    _f[api_1.Injuries.SOFT_TISSUE] = "Soft Tissue(Sprains, strains, bruises)",
    _f[api_1.Injuries.NECK_AND_BACK] = "Neck and back pain",
    _f[api_1.Injuries.TOOTH] = "Tooth damage",
    _f[api_1.Injuries.OTHER] = "Other",
    _f);
exports.CSADisplayText = (_g = {},
    _g[api_1.CSAType.PLO] = "PLO",
    _g[api_1.CSAType.STANDARD] = "Standard",
    _g[api_1.CSAType.FORTY_FIVE_TO_FIFTY] = "45-50",
    _g[api_1.CSAType.FORTY_TO_FORTY_FIVE_FIFTY] = "40-45-50",
    _g[api_1.CSAType.CLASS_ACTION] = "Class Action",
    _g[api_1.CSAType.PAGA] = "PAGA",
    _g);
exports.ReasonForKeepPIDisplayText = (_h = {},
    _h[api_1.ReasonForKeepPI.AUTO] = "Auto",
    _h[api_1.ReasonForKeepPI.PREMISES_LIABILITY] = "Premises Liability",
    _h[api_1.ReasonForKeepPI.MED_MAL] = "Med-Mal",
    _h);
exports.ReasonForDeclinePIDisplayText = (_j = {},
    _j[api_1.ReasonForDeclinePI.AUTO] = "Auto",
    _j[api_1.ReasonForDeclinePI.PREMISES_LIABILITY] = "Premises Liability",
    _j[api_1.ReasonForDeclinePI.MED_MAL] = "Med-Mal",
    _j[api_1.ReasonForDeclinePI.OTHER] = "Other",
    _j);
exports.ReasonForReferPIDisplayText = (_k = {},
    _k[api_1.ReasonForReferPI.EASY_AUTO] = "Easy Auto",
    _k[api_1.ReasonForReferPI.NBCAUTO] = "Issue Auto",
    _k[api_1.ReasonForReferPI.EASY_PREMISES_LIABILITY] = "Easy Premises Liability",
    _k[api_1.ReasonForReferPI.CIVIL_RIGHTS] = "Civil Rights",
    _k);
exports.ReasonForDeclineWCDisplayText = (_l = {},
    _l[api_1.ReasonForNgcWC.MENTAL] = "Mental",
    _l[api_1.ReasonForNgcWC.SOL] = "SOL",
    _l[api_1.ReasonForNgcWC.GLUCK_DECLINED] = "Gluck Declined",
    _l[api_1.ReasonForNgcWC.RATTO_DECLINED] = "Ratto Declined",
    _l[api_1.ReasonForNgcWC.LEAD_DECLINED] = "Lead Declined/Not Interested",
    _l[api_1.ReasonForNgcWC.OUT_OF_STATE] = "Out of State",
    _l[api_1.ReasonForNgcWC.NOT_WC] = "Not WC Case",
    _l[api_1.ReasonForNgcWC.NO_PAYSTUBS] = "Does Not Receive Paystubs",
    _l[api_1.ReasonForNgcWC.DID_NOT_REPORT] = "Did not report/Did not seek medical attention",
    _l[api_1.ReasonForNgcWC.ALREADY_HAS_SETTLEMENT] = "Already received a settlement",
    _l[api_1.ReasonForNgcWC.ALREADY_REPRESENTED] = "Already Represented and not looking for SOA",
    _l[api_1.ReasonForNgcWC.NO_WCINSURANCE] = "Employer does not have WC insurance",
    _l[api_1.ReasonForNgcWC.REPRIMANDED] = "Reprimanded before considering filing for WC",
    _l[api_1.ReasonForNgcWC.CREDIBILITY] = "Credibility",
    _l[api_1.ReasonForNgcWC.NO_INJURIES] = "No Injuries",
    _l[api_1.ReasonForNgcWC.GOVERNMENT_ENTITY] = "Government Entity",
    _l);
exports.ReasonForNAEmpDisplayMapping = (_m = {},
    _m[api_1.ReasonForNAEmp.EVIDENCE_NOT_STRONG] = "Evidence not Strong Enough / Signed Severance / Union",
    _m[api_1.ReasonForNAEmp.NOT_EXAUSTED_UNION] = "Have Not Exhausted Union Remedy",
    _m[api_1.ReasonForNAEmp.NOT_ILLEGAL] = "Not Illegal",
    _m[api_1.ReasonForNAEmp.CREDIBILITY] = "Credibility",
    _m[api_1.ReasonForNAEmp.INSUFFICIENT_FUNDS] = "Entity Too Small / Insufficient Funds",
    _m[api_1.ReasonForNAEmp.REFER_TO_LABOR] = "Claims Too Small / Refer to Labor Board",
    _m[api_1.ReasonForNAEmp.GIG_OR_GOVERNMENT] = "Gig or Government",
    _m[api_1.ReasonForNAEmp.SOL_EXPIRED] = "SOL Expired",
    _m[api_1.ReasonForNAEmp.REPRESENTED] = "Already Represented",
    _m[api_1.ReasonForNAEmp.SIGNED_SEVERANCE] = "Signed Severance",
    _m[api_1.ReasonForNAEmp.OUT_OF_STATE] = "Out of State",
    _m[api_1.ReasonForNAEmp.NOT_PLAINTIFF_CLAIM] = "Not a Plaintiff Employment Claim",
    _m[api_1.ReasonForNAEmp.REFER_WC] = "Refer to WC",
    _m[api_1.ReasonForNAEmp.NON_RESPONSIVE] = "Non-Responsive",
    _m[api_1.ReasonForNAEmp.OTHER] = "Other",
    _m);
exports.ReasonForPIEmpDisplayMapping = (_o = {},
    _o[api_1.ReasonForNAPI.SUSPECTED_COMPETITOR] = "Suspected Competitor",
    _o[api_1.ReasonForNAPI.NO_INJURIES] = "No Injuries",
    _o[api_1.ReasonForNAPI.NOT_PI] = "Not a PI case",
    _o[api_1.ReasonForNAPI.DISCONNECT] = "Disconnected/Wrong number",
    _o[api_1.ReasonForNAPI.NO_INSURANCE] = "No Insurance/License",
    _o[api_1.ReasonForNAPI.CREDIBILITY] = "Credibility",
    _o[api_1.ReasonForNAPI.SOL_EXPIRED] = "SOL Expired",
    _o[api_1.ReasonForNAPI.NON_RESPONSIVE] = "Non-Responsive",
    _o[api_1.ReasonForNAPI.EVIDENCE_NOT_STRONG] = "Evidence Not Strong Enough",
    _o[api_1.ReasonForNAPI.RECEIVED_SETTLEMENT] = "Received Settlement",
    _o[api_1.ReasonForNAPI.ALREADY_REPRESENTED] = "Already Represented/Does not want to sub out",
    _o[api_1.ReasonForNAPI.OUT_OF_STATE] = "Out Of State",
    _o[api_1.ReasonForNAPI.CHANGED_MIND] = "Lead Changed Their Mind",
    _o[api_1.ReasonForNAPI.OTHER] = "Other",
    _o);
exports.clientDataSchema = yup.object().shape({
    firstName: yup.string().required(),
    lastName: yup.string().required(),
    phone: yup
        .string()
        .required(),
    // .test("is-valid-phone", "Invalid phone", function (value) {
    //   return matchIsValidTel(value);
    // }),
    email: yup.string().email().required(),
    birthDate: yup.mixed().required(),
});
exports.maxFileSize = 104857600;
exports.usersToTrackTime = [1, 40, 42, 62, 66, 69, 72, 131];
var LitigationAreas;
(function (LitigationAreas) {
    LitigationAreas["LitigationFunnelState"] = "LitigationFunnelState";
    LitigationAreas["DefendantsDeposition"] = "DefendantsDeposition";
    LitigationAreas["DiscoveryResponses"] = "DiscoveryResponses";
    LitigationAreas["PlaintiffDepo"] = "PlaintiffDepo";
    LitigationAreas["Pleadings"] = "Pleadings";
    LitigationAreas["CaseManagementConference"] = "CaseManagementConference";
    LitigationAreas["Manual"] = "Manual";
    LitigationAreas["OutsideTrigger"] = "OutsideTrigger";
    LitigationAreas["OutsideSingle"] = "OutsideSingle";
    LitigationAreas["Mediation"] = "Mediation";
})(LitigationAreas = exports.LitigationAreas || (exports.LitigationAreas = {}));
var LitigationStages;
(function (LitigationStages) {
    // Litigation Funnel State
    LitigationStages["ServiceConfirmation"] = "ServiceConfirmation";
    LitigationStages["ServiceOfWrittenDiscovery"] = "ServiceOfWrittenDiscovery";
    LitigationStages["DiscoveryProcessPRequestsToD"] = "DiscoveryProcessPRequestsToD";
    LitigationStages["PreparePostDiscoveryCaseEvaluationMemo"] = "PreparePostDiscoveryCaseEvaluationMemo";
    // Defendant's Deposition
    LitigationStages["DefendantsDeposition"] = "DefendantsDeposition";
    // Discovery Responses
    LitigationStages["DiscoveryProcessPResponsesToD"] = "DiscoveryProcessPResponsesToD";
    // Plaintiff's Depo
    LitigationStages["PlaintiffsDeposition"] = "PlaintiffsDeposition";
    LitigationStages["ObtainDepositionTranscript"] = "ObtainDepositionTranscript";
    // Pleadings
    LitigationStages["Pleadings"] = "Pleadings";
    // Case Management Conference
    LitigationStages["PleadingCaseManagementConference"] = "PleadingCaseManagementConference";
    // Manual
    LitigationStages["Manual"] = "Manual";
    // Outside Trigger
    LitigationStages["DiscoveryRequestSet2"] = "DiscoveryRequestSet2";
    LitigationStages["DiscoveryRequestSet3"] = "DiscoveryRequestSet3";
    LitigationStages["MotionToCompel"] = "MotionToCompel";
    LitigationStages["ResponseToOppositionToMotion"] = "ResponseToOppositionToMotion";
    LitigationStages["DepositionObjection"] = "DepositionObjection";
    LitigationStages["PleadingsNoResponseFromDefendant"] = "PleadingsNoResponseFromDefendant";
    LitigationStages["DemurrerOpposition"] = "DemurrerOpposition";
    LitigationStages["InitialTrialSettingConferenceTSC"] = "InitialTrialSettingConferenceTSC";
    // Outside Single
    LitigationStages["ServeInitialDisclousureDemand"] = "ServeInitialDisclousureDemand";
    LitigationStages["NegotiationsLitigationArbitration"] = "NegotiationsLitigationArbitration";
    // Mediation
    LitigationStages["SendListOfMediatorsToOC"] = "SendListOfMediatorsToOC";
    LitigationStages["ConfirmOrFollowUpWithOCOnMediatorSelection"] = "ConfirmOrFollowUpWithOCOnMediatorSelection";
    LitigationStages["ResearchAndUpdateMediatorInformation"] = "ResearchAndUpdateMediatorInformation";
    LitigationStages["RequestDatesFromMediator"] = "RequestDatesFromMediator";
    LitigationStages["SendProposedMediationDatesToClientAndToOC"] = "SendProposedMediationDatesToClientAndToOC";
    LitigationStages["ConfirmMediationDateWithTheOpposingCounselAndScheduleIt"] = "ConfirmMediationDateWithTheOpposingCounselAndScheduleIt";
    LitigationStages["SendAndSignMediationNotice"] = "SendAndSignMediationNotice";
    LitigationStages["ObtainAndCalendarMediationDeadlines"] = "ObtainAndCalendarMediationDeadlines";
    LitigationStages["DraftMediationBrief"] = "DraftMediationBrief";
    LitigationStages["ReviewOfMediationBrief"] = "ReviewOfMediationBrief";
    LitigationStages["SubmitMediationBrief"] = "SubmitMediationBrief";
    LitigationStages["ScheduleMediationPrepCall"] = "ScheduleMediationPrepCall";
    LitigationStages["AttendMediation"] = "AttendMediation";
    LitigationStages["ProvidePostMediationFeedbackOnMediator"] = "ProvidePostMediationFeedbackOnMediator";
})(LitigationStages = exports.LitigationStages || (exports.LitigationStages = {}));
//# sourceMappingURL=Constants.js.map